import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'spa-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  @Input() title: string | undefined;
  @Input() subtitle: string | undefined;

  constructor() {}
}
